import React from 'react'
import { Modal, Descriptions, Row, Col, Divider, Tag } from 'antd'
import moment from 'moment'

const SalaryVpDetailModal = props => {
  const { visible, onClose, data } = props

  if (!data) return null

  const formatCurrencyText = val => {
    if (val === null || val === undefined || val === '') return '-'
    const numericValue =
      typeof val === 'number'
        ? val
        : Number(
            String(val)
              .replace(/[^0-9,.-]/g, '')
              .replace(/,/g, '')
          )
    if (!Number.isFinite(numericValue)) return '-'
    return new Intl.NumberFormat().format(numericValue)
  }

  const formatCurrency = val => {
    const text = formatCurrencyText(val)
    return text === '-' ? (
      '-'
    ) : (
      <span style={{ fontWeight: '500' }}>{text}</span>
    )
  }
  const formatNumber = val =>
    val !== null && val !== undefined && val !== '' ? (
      <span style={{ fontWeight: '500' }}>{val}</span>
    ) : (
      '-'
    )
  const formatBhxhYn = val => {
    if (val === null || val === undefined || val === '') return '-'
    if (typeof val === 'string') {
      const normalized = val.trim().toUpperCase()
      if (normalized === 'Y' || normalized === '1') return 'Có'
      if (normalized === 'N' || normalized === '0') return 'Không'
      return '-'
    }
    if (val === 1 || val === true) return 'Có'
    if (val === 0 || val === false) return 'Không'
    return '-'
  }

  return (
    <Modal
      title={
        'Chi tiết bảng lương tháng ' +
        (data.salary_month ? moment(data.salary_month).format('MM/YYYY') : '')
      }
      visible={visible}
      onCancel={onClose}
      footer={null}
      width={1000}
      centered>
      <Descriptions
        title="Thông tin nhân viên"
        bordered
        size="small"
        column={2}>
        <Descriptions.Item label="Mã nhân viên">{data.ma_nv}</Descriptions.Item>
        <Descriptions.Item label="Họ và tên">
          {data.ho_va_ten}
        </Descriptions.Item>
        <Descriptions.Item label="Chức danh công việc" span={2}>
          {data.chuc_danh_cong_viec}
        </Descriptions.Item>
        <Descriptions.Item label="Hình thức lương">
          <Tag color="blue">{data.hinh_thuc_luong || 'V'}</Tag>
        </Descriptions.Item>
      </Descriptions>

      <Divider orientation="left">Lương & Công</Divider>
      <Row gutter={[16, 16]}>
        <Col span={12}>
          <Descriptions bordered size="small" column={1}>
            <Descriptions.Item label="Hệ số lương P1">
              {formatNumber(data.he_so_luong_p1)}
            </Descriptions.Item>
            <Descriptions.Item label="Hệ số lương P2">
              {formatNumber(data.he_so_luong_p2)}
            </Descriptions.Item>
            <Descriptions.Item label="Hệ số lương P3">
              {formatNumber(data.he_so_luong_p3)}
            </Descriptions.Item>
            <Descriptions.Item label="Hệ số HTNV (KPI)">
              {formatNumber(data.he_so_htnv)}
            </Descriptions.Item>
            <Descriptions.Item label="Ngày công">
              {formatNumber(data.ngay_cong)}
            </Descriptions.Item>
          </Descriptions>
        </Col>
        <Col span={12}>
          <Descriptions bordered size="small" column={1}>
            <Descriptions.Item label="Tiền lương P1">
              {formatCurrency(data.tien_luong_p1)}
            </Descriptions.Item>
            <Descriptions.Item label="Tiền lương P2">
              {formatCurrency(data.tien_luong_p2)}
            </Descriptions.Item>
            <Descriptions.Item label="Tiền thưởng năng suất">
              {formatCurrency(data.tien_thuong_nang_suat)}
            </Descriptions.Item>
            <Descriptions.Item label="Tổng tiền lương (P1+P2+thưởng năng suất)">
              {formatCurrency(data.tong_tien_luong)}
            </Descriptions.Item>
          </Descriptions>
        </Col>
      </Row>

      <Divider orientation="left">Phụ cấp & Làm thêm</Divider>
      <Descriptions bordered size="small" column={2}>
        <Descriptions.Item label="Phụ cấp trách nhiệm">
          {formatCurrency(data.phu_cap_trach_nhiem)}
        </Descriptions.Item>
        <Descriptions.Item label="Ngày PCLĐ">
          {data.ngay_pcld}
        </Descriptions.Item>
        <Descriptions.Item label="Phụ cấp thu hút">
          {formatCurrency(data.phu_cap_thu_hut)}
        </Descriptions.Item>
        <Descriptions.Item label="Phụ cấp lưu động">
          {formatCurrency(data.phu_cap_luu_dong)}
        </Descriptions.Item>
        <Descriptions.Item label="Phụ cấp kiêm nhiệm">
          {formatCurrency(data.phu_cap_kiem_nhiem)}
        </Descriptions.Item>
        <Descriptions.Item label="Phụ cấp thâm niên vượt khung">
          {formatCurrency(data.phu_cap_tham_nien_vuot_khung)}
        </Descriptions.Item>
        <Descriptions.Item label="Công làm đêm">
          {formatNumber(data.cong_lam_dem)}
        </Descriptions.Item>
        <Descriptions.Item label="Tiền lương tính thêm khi làm đêm">
          {formatCurrency(data.tien_luong_lam_dem)}
        </Descriptions.Item>
        <Descriptions.Item label="Giờ làm thêm">
          {formatNumber(data.gio_lam_them)}
        </Descriptions.Item>
        <Descriptions.Item label="Giờ LT quy đổi">
          {formatNumber(data.gio_lt_quy_doi)}
        </Descriptions.Item>
        <Descriptions.Item label="Tiền lương làm thêm giờ">
          {formatCurrency(data.tien_luong_lam_them_gio)}
        </Descriptions.Item>
        <Descriptions.Item label="TĐ: TL tính thêm khi làm thêm giờ">
          {formatCurrency(data.td_tl_tinh_them_lam_them_gio)}
        </Descriptions.Item>
      </Descriptions>

      <Divider orientation="left">Nghỉ chế độ & Ngừng việc</Divider>
      <Descriptions bordered size="small" column={2}>
        <Descriptions.Item label="Công nghỉ chế độ">
          {formatNumber(data.cong_nghi_che_do)}
        </Descriptions.Item>
        <Descriptions.Item label="Tiền lương nghỉ chế độ">
          {formatCurrency(data.tien_luong_nghi_che_do)}
        </Descriptions.Item>
        <Descriptions.Item label="Giờ ngừng, chờ việc">
          {formatNumber(data.gio_ngung_cho_viec)}
        </Descriptions.Item>
        <Descriptions.Item label="Tiền lương ngừng việc">
          {formatCurrency(data.tien_luong_ngung_cho_viec)}
        </Descriptions.Item>
        <Descriptions.Item label="Tiền lương khác (TNLĐ,…)">
          {formatCurrency(data.tien_luong_khac)}
        </Descriptions.Item>
      </Descriptions>

      <Divider orientation="left">Thu nhập & Khấu trừ</Divider>
      <Row gutter={[16, 16]}>
        <Col span={12}>
          <Descriptions bordered size="small" column={1} title="Khoản cộng">
            <Descriptions.Item label="Hỗ trợ tiền ăn">
              {formatCurrency(data.ho_tro_tien_an)}
            </Descriptions.Item>
            <Descriptions.Item label="Hỗ trợ xăng xe">
              {formatCurrency(data.ho_tro_xang_xe)}
            </Descriptions.Item>
            <Descriptions.Item
              label="Tổng thu nhập tiền lương"
              style={{ backgroundColor: '#f6ffed' }}>
              {formatCurrency(data.tong_thu_nhap_tien_luong)}
            </Descriptions.Item>
          </Descriptions>
        </Col>
        <Col span={12}>
          <Descriptions bordered size="small" column={1} title="Khoản trừ">
            <Descriptions.Item label="Đóng BHXH (Y/N)">
              {formatBhxhYn(data.dong_bhxh)}
            </Descriptions.Item>
            <Descriptions.Item label="Bảo hiểm xã hội">
              {formatCurrency(data.bao_hiem_xa_hoi)}
            </Descriptions.Item>
            <Descriptions.Item label="Bảo hiểm y tế">
              {formatCurrency(data.bao_hiem_y_te)}
            </Descriptions.Item>
            <Descriptions.Item label="Bảo hiểm thất nghiệp">
              {formatCurrency(data.bao_hiem_that_nghiep)}
            </Descriptions.Item>
            <Descriptions.Item label="Thu nhập tính thuế (tạm tính)">
              {formatCurrency(data.thu_nhap_tinh_thue)}
            </Descriptions.Item>
            <Descriptions.Item label="Thuế TNCN">
              {formatCurrency(data.thue_tncn)}
            </Descriptions.Item>
            <Descriptions.Item label="Khoản trừ khác">
              {formatCurrency(data.khoan_tru_khac)}
            </Descriptions.Item>
            <Descriptions.Item label="Hỗ trợ trừ Đảng phí">
              {formatCurrency(data.ho_tro_tru_dang_phi)}
            </Descriptions.Item>
            <Descriptions.Item label="Hỗ trợ trừ Công đoàn">
              {formatCurrency(data.ho_tro_tru_df_cong_doan)}
            </Descriptions.Item>
            <Descriptions.Item label="Hỗ trợ ( Thiên tai, nhân đạo, Hội chữ thập đỏ....)">
              {formatCurrency(data.ho_tro_dong_bao_thiet_hai)}
            </Descriptions.Item>
            <Descriptions.Item
              label="Tổng khấu trừ"
              style={{ backgroundColor: '#fff1f0' }}>
              {formatCurrency(data.tong_khau_tru)}
            </Descriptions.Item>
          </Descriptions>
        </Col>
      </Row>

      <Divider />
      <Descriptions bordered size="small" column={1}>
        <Descriptions.Item
          label={
            <span style={{ fontWeight: 'bold', fontSize: '1.1em' }}>
              Thu nhập tiền lương thực lĩnh
            </span>
          }>
          <span style={{ fontWeight: 'bold', fontSize: '1.2em' }}>
            {formatCurrencyText(data.thu_nhap_thuc_linh)}
          </span>
        </Descriptions.Item>
        <Descriptions.Item label="Ghi chú">{data.ghi_chu}</Descriptions.Item>
      </Descriptions>
    </Modal>
  )
}

export default SalaryVpDetailModal
